import * as React from 'react';
import {FormattedMessage} from 'react-intl';
import translations from './translations';


export const TopNav: React.SFC<{}> = () => {
    return (
    <>
      <h1 className="title"> <FormattedMessage {...translations.tntitle} /></h1>
      <nav className="level">
          <div className="level-left">
              <div className="level-item">
                  <p className="subtitle is-5">
                  <FormattedMessage {...translations.tnheading} />
                  </p>
              </div>
          </div>
      </nav>
    </>
    )
};



// WEBPACK FOOTER //
// ./src/Containers/Profile/TopNav.tsx